<template>
  <div
    v-if="ready && isAllowed('edit_users')"
    class="w-full template"
  >
    <h1>Mitarbeiter hinzufügen</h1>

    <form @submit.prevent="save">
      <user v-model="user" />
    </form>

    <div class="w-full mt-12">
      <input
        type="button"
        class="block p-2 rounded border bg-orange-mia text-white font-bold"
        value="Mitarbeiter hinzufügen"
        @click="save()"
      >
    </div>
  </div>
</template>

<script>

import User from '@/components/forms/user.vue'

export default {

  components: {
    User
  },

  data() {
    return {
      ready: true,
      user: {
        item_active: 'Y',
        item_show_on_website: 'N',
        item_dealer: [],
        item_roles: [],
        item_permissions: []
      }
    }
  },

  mounted() {
    eventBus.$emit('mia-loading-ended')
    if (!this.isAllowed('edit_users')) return

    eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/users'
        },
        text: 'Mitarbeiter verwalten'
      },
      {
        link: {
          path: '/user/add'
        },
        text: 'Mitarbeiter hinzufügen'
      }
    ])
  },

  methods: {
    save() {
      eventBus.$emit('mia-loading-started')

      const formData = new FormData()
      Object.entries(this.user).forEach(([key, value]) => {
        if (['item_roles', 'item_permissions'].includes(key)) {
          return
        }

        formData.set(key, value)
      })

      // Handle new roles and permissions
      if ([1, 2].includes(parseInt(this.authDealer.id, 10))) {
        if (this.user.item_roles.length === 0) {
          formData.set('item_roles', '')
        } else {
          this.user.item_roles.forEach((role, index) => {
            formData.set(`item_roles[${index}]`, role.id)
          })
        }

        if (this.user.item_permissions.length === 0) {
          formData.set('item_permissions', '')
        } else {
          // Handle legacy permissions
          const legacyPermissions = this.user.item_permissions.filter(permission => permission.item_is_legacy === 'Y')

          legacyPermissions.forEach((permission) => {
            formData.set(permission.id, 'true')
          })

          const newPermissions = this.user.item_permissions.filter(permission => permission.item_is_legacy !== 'Y')

          if (newPermissions.length === 0) {
            formData.set('item_permissions', '')
          } else {
            newPermissions.forEach((permission, index) => {
              formData.set(`item_permissions[${index}]`, permission.item_name)
            })
          }
        }
      }

      axios.post(`${window.baseUrl}/user/adduser`, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
        .then(({ data }) => {
          eventBus.$emit('mia-info', {
            info: [data.message]
          })
        }).finally(() => {
          eventBus.$emit('mia-loading-ended')
        })
    }
  }
}
</script>
